import { NotificationType } from 'wflow-cdk';

export type ToastTypeParams = {
  icon: string;
  iconClass: string;
};

export const TOAST_TYPES_MAP: {
  [key in NotificationType]: ToastTypeParams;
} = {
  success: {
    icon: 'check-circle',
    iconClass: 'green',
  },
  warning: {
    icon: 'alert-triangle',
    iconClass: 'orange',
  },
  error: {
    icon: 'alert-circle',
    iconClass: 'red',
  },
  info: {
    icon: 'info-circle',
    iconClass: 'primary',
  },
};
